// Document status display helpers. Status strings come from Firestore
// and are rendered in badges, outlines, and emoji prefixes throughout
// the SOP viewer and notifications panel.

export const getStatusBadgeClass = (status) => {
  switch (status) {
    case 'New':
      return 'bg-blue-100 text-blue-800 status-new-badge';
    case 'Updated':
      return 'bg-orange-100 text-orange-800 status-updated-badge';
    case 'Urgent':
      return 'bg-red-100 text-red-800 status-urgent-badge';
    case 'Expired':
      return 'bg-gray-100 text-gray-800';
    case 'Active!':
      return 'bg-green-100 text-green-800 status-active-badge';
    case 'Pinned':
      return 'bg-amber-100 text-amber-800';
    default:
      return 'hidden';
  }
};

export const getStatusOutlineClass = (status) => {
  switch (status) {
    case 'New':
      return 'border-blue-500 ring-1 ring-blue-200';
    case 'Updated':
      return 'border-orange-500 ring-1 ring-orange-200';
    case 'Urgent':
      return 'border-red-500 ring-1 ring-red-200';
    case 'Active!':
      return 'border-green-500 ring-1 ring-green-200';
    default:
      return '';
  }
};

export const getStatusEmoji = (status) => {
  switch (status) {
    case 'New': return '🆕';
    case 'Updated': return '🔄';
    case 'Urgent': return '🚨';
    case 'Active!': return '🔥';
    case 'Pinned': return '📌';
    case 'Expired': return '🗄️';
    default: return '';
  }
};
